module.exports = __webpack_public_path__ + "static/img/photo5.5673aec7.jpg";